import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba812f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-flex p-1 bg-neutral-800 rounded text-neutral-400" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "value"]


const __default__ = {
    inheritAttrs: false,
    customOptions: {},
};

import { PlusIcon, MinusIcon } from "@heroicons/vue/24/outline";
import AppButton from "@/components/app/AppButton.vue";

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InputNumber',
  props: ["modelValue", "id", "label", "max", "min"],
  emits: ["update:modelValue"],
  setup(__props, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: __props.id,
      class: "sr-only"
    }, _toDisplayString(__props.label), 9, _hoisted_2),
    _createVNode(AppButton, {
      size: "xs",
      "only-icon": "",
      color: "gray",
      rounded: "base",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('update:modelValue', __props.modelValue - 1)), ["prevent"])),
      disabled: !!__props.min ? __props.modelValue <= Number(__props.min) : false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MinusIcon), { class: "w-4 h-4" })
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      type: "number",
      class: "inline-flex items-center text-neutral-50 w-8 h-6 text-center text-base font-normal bg-transparent m-0 !border-none !outline-none",
      id: __props.id,
      value: __props.modelValue,
      readonly: ""
    }), null, 16, _hoisted_3),
    _createVNode(AppButton, {
      size: "xs",
      "only-icon": "",
      color: "gray",
      rounded: "base",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('update:modelValue', __props.modelValue + 1)), ["prevent"])),
      disabled: !!__props.max ? __props.modelValue >= Number(__props.max) : false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(PlusIcon), { class: "w-4 h-4" })
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})